export default __webpack_public_path__ + "static/media/screen3.c83f3d02.png";